export const theme = {
  breakpoints: ['576px', '768px', '992px', '1200px', '1400px'],
  grid: {
    container: '130rem',
    gutter: '3.2rem',
  },
  border: {
    xsmallRadius: '4px',
    smallRadius: '8px',
    normal: '10px',
    mediumRadius: '16px',
    largeRadius: '24px',
  },
  font: {
    montserrat: 'Montserrat, sans-serif',
    inter: 'Inter, sans-serif',
    workSans: 'Work Sans, sans-serif',
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    sizes: {
      xxsmall: '0.625rem',
      xsmall: '0.75rem',
      small: '0.875rem',
      normal: '1rem',
      medium: '1.125rem',
      large: '1.25rem',
      xlarge: '1.5rem',
      xxlarge: '1.875rem',
      huge: '4rem',
    },
  },
  colors: {
    mainBg: '#FFFFFF',
    white: '#FFFFFF',
    lightGray: '#FBFAFC',
    secondGray: '#E0E0E0',
    secondLightGray: '#F5F5F5',
    thirdLightGray: '#f2f2f2',
    gray: '#B9C1CB',
    mediumGray: '#929BA8',
    secondMediumGray: '#B9C1CB',
    darkGray: '#5F7089',
    blackLight: '#252A31',
    black: '#222222',
    red: '#D21C1C',
    redLight: '#EB5757',
    wineRed: '#8F1800',
    orange: '#DF5605',
    lightOrange: '#FFBA92',
    lightBrown: '#796C5F',
    brown: '#3C2E21',
    darkGreen: '#648908',
    mediumGreen: '#7FAE0B',
    green: '#11B355',
    lightGreen: '#CBF5C7',
    yellow: '#E8BC4B',
    mediumYellow: '#FFB800',
    lightYellow: '#FFFADF',
    lightPink: '#FFCECE',
    lightBlue: '#C8E7FF',
    blue: '#0172CB',
    blueLight: '#2F80ED',
    iris: '#5D5FEF',
    gradients: {
      brown: 'linear-gradient(98.6deg, #3C2E21 7.49%, #796C5F 98.19%)',
      green: 'linear-gradient(98.6deg, #648908 7.49%, #7FAE0B 98.19%)',
      yellow: 'linear-gradient(305.05deg, #F5CE69 -1.32%, #FFFADF 97.09%)',
    },
    overlay: {
      primary: 'rgba(0,0,0,.4)',
    },
  },
  transition: {
    default: '0.2s ease-in-out',
    fast: '0.1s ease-in-out',
  },
}
